import { getBlankDetails } from "./helpers";
import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";

export const mutations = {
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.SYSTEM_DETAILS_GET_STARTED](state) {
    stateMerge(state.details, getBlankDetails());
    state.details.loading = true;
  },
  [mutation.SYSTEM_DETAILS_GET_SUCCEEDED](state, details) {
    stateMerge(state.details, details);
    state.details.loading = false;
    state.details.loaded = true;
  },
  [mutation.SYSTEM_DETAILS_GET_FAILED](state) {
    stateMerge(state.details, getBlankDetails());
    state.details.loading = false;
    state.details.loaded = false;
  },

  [mutation.REBUILD_INITIALISE](state) {
    state.rebuild.processing = false;
  },
  [mutation.REBUILD_STARTED](state) {
    state.rebuild.processing = true;
  },
  [mutation.REBUILD_SUCCEEDED](state) {
    state.rebuild.processing = false;
  },
  [mutation.REBUILD_FAILED](state, errorDetails) {
    state.rebuild.processing = false;
    state.rebuild.error.show = true;
    state.rebuild.error.details = errorDetails;
  },

  [mutation.CLEAR_LEVY_COLLECTION_STARTED](state) {
    state.clearProviders.clearing = true;
  },
  [mutation.CLEAR_LEVY_COLLECTION_SUCCEEDED](state) {
    state.clearProviders.clearing = false;
  },
  [mutation.CLEAR_LEVY_COLLECTION_FAILED](state) {
    state.clearProviders.clearing = false;
  },

  [mutation.SEED_SAMPLE_INVOICES_STARTED](state) {
    state.invoiceSeeding.processing = true;
  },
  [mutation.SEED_SAMPLE_INVOICES_SUCCEEDED](state) {
    state.invoiceSeeding.processing = false;
  },
  [mutation.SEED_SAMPLE_INVOICES_FAILED](state) {
    state.invoiceSeeding.processing = false;
  },

  [mutation.DISABLE_TESTING_TOOLS](state) {
    state.details.disableTestingTools = true;
  },

  [mutation.GLOBAL_ERROR](state, error) {
    if (!state.globalError.fatal) {
      state.globalError.details = error;
      state.globalError.show = true;
    }
  },
  [mutation.GLOBAL_ERROR_FATAL](state, error) {
    state.globalError.details = error;
    state.globalError.show = true;
    state.globalError.fatal = true;
  },
  [mutation.GLOBAL_ERROR_HIDE](state) {
    state.globalError.show = false;
  },

  [mutation.APP_SETTINGS_GET_STARTED](state) {
    state.appSettings.loading = true;
  },
  [mutation.APP_SETTINGS_GET_SUCCEEDED](state, data) {
    state.appSettings.loading = false;
    state.appSettings.loaded = true;
    stateMerge(state.appSettings.data, data);
  },
  [mutation.APP_SETTINGS_GET_FAILED](state) {
    state.appSettings.loading = false;
    state.appSettings.loaded = false;
  },

  [mutation.SAP_CONFIGURATION_GET_STARTED](state, levyCollectionType) {
    state.sapConfiguration.loading = true;
    state.sapConfiguration.levyCollectionType = levyCollectionType;
  },
  [mutation.SAP_CONFIGURATION_GET_SUCCEEDED](state, configuration) {
    state.sapConfiguration.loading = false;
    state.sapConfiguration.loaded = true;
    stateMerge(state.sapConfiguration.data, configuration);
  },
  [mutation.SAP_CONFIGURATION_GET_FAILED](state) {
    state.sapConfiguration.loading = false;
    state.sapConfiguration.loaded = false;
  }
};
